import React, { Component } from 'react';

class About extends Component {
  render() {
    return (
      <div className="about">
        <h2>About Me</h2>
        <p>I am a creative full stack developer with a passion for building design focused user experiences.</p>
        <p>
          I graduated from New York University's Gallatin School of Individualized Study where I studied the intersection of anthropology, web development and fashion.
        </p>
        <p>Since then I have split my time between building websites and applications for a variety of clients and teaching Software Engineering at <a rel="noopener noreferrer" target="_blank" href="https://generalassemb.ly/instructors/madeline-o-moore/11794">General Assembly </a>.</p>

        <p id="email">
          If you want work together, you can email me here:  <a rel="noopener noreferrer" href="mailto:madeline@done-digital.com">madeline@done-digital.com</a>
        </p>

        <p>I write code using:</p>
        <ul>
          <li>JavaScript</li>
          <li>React</li>
          <li>TypeScript</li>
          <li>GraphQl</li>
          <li>SQL</li>
          <li>Shopify/Liquid</li>
          <li>PhP/Wordpress</li>
          <li>Ruby</li>
          <li>Rails</li>
        </ul>
      </div>
    );
  }
}

export default About;



// WEBPACK FOOTER //
// ./src/Pages/About.js